export default __webpack_public_path__ + "static/instar-alexa-8001-da3f22f12cc44227afdb37553657a0ac.webp";